module.exports = require('./helpers/bundle-url').getBundleURL('a0IFD') + "taxaroo-logo.7a3ce4e2.png";